<template>
    <Nav />
    <Content>
        <div class="level">
            <div class="level-left">
                <h1 class="title">Sound Details</h1>
            </div>
            <div class="level-right">   

                <template v-if="isAdmin && !this.$route.query.code">
                    <ShareFileButton
                        :isAdmin="isAdmin"
                        :fileId="id"
                    />
                </template>

                <DownloadLabelsDropdown 
                    class="m-1 p-1"
                    :sound="{
                        'detections': detections,
                        'fileName': sound.file_name,
                        'requesting_user': requesting_user,
                        'id': id
                    }"
                />

                <DownloadDetectionsButton
                    :sound="{
                        'detections': detections,
                        'fileName': sound.file_name,
                        'requesting_user': requesting_user,
                        'id': id 
                    }"
                />

                <DownloadAudioButton 
                    :requesting_user="requesting_user"
                    :object_key="sound.object_key"
                />

            </div>
        </div>

        <SoundDetailsBoxed 
            :sound="sound"
            :isAdmin="isAdmin"
        />

        <DetectionTableGrouped
            :detections="detections"
        />

        <MlRequestOptions 
            v-if="isAdmin"
            :requestingUser="requesting_user"
            :token="tokens.id_token"
            :soundIds="[id]"
        />
    </Content>
    <Footer />
</template>

<script>
// layout components
import Nav from '@/components/Nav.vue'
import Content from '@/components/Content.vue'
import Footer from '@/components/Footer.vue'
// sound detail components
import DownloadLabelsDropdown from '@/components/sounds/sound-details/DownloadLabelsDropdown.vue'
import DownloadDetectionsButton from '@/components/sounds/sound-details/DownloadDetectionsButton.vue'
import DownloadAudioButton from '@/components/sounds/sound-details/DownloadAudioButton.vue'
import SoundDetailsBoxed from '@/components/sounds/sound-details/SoundDetailsBoxed.vue'
import DetectionTableGrouped from '@/components/sounds/detections/DetectionTableGrouped.vue'
import MlRequestOptions from '@/components/sounds/sound-details/MlRequestOptions.vue'
import ShareFileButton from '@/components/sounds/sound-details/ShareFileButton.vue'
// other
import { mapState, mapActions } from 'pinia'
import { useLogin  } from '@/js/auth.js'
import { getDetections, getSound } from '@/js/apis.js'
import { codeB64 } from '@/js/codeValidator'

export default {
    name: 'SoundDetailsView',
    components: {
      Nav,
      Footer,
      Content,
      DownloadLabelsDropdown,
      DownloadDetectionsButton,
      DownloadAudioButton,
      SoundDetailsBoxed,
      DetectionTableGrouped,
      MlRequestOptions,
      ShareFileButton
    },
    data() {
        return {
            sound: {},
            detections: [],
        }
    },
    mounted() {
        this.updateSound()
        this.updateDetections()
    },
    methods: {
        updateSound(){
            console.log(
                "SoundSingleView.updateSound",
                this.requesting_user,
                this.id,
            )
            getSound(this.requesting_user, this.id)
                .then((res, err) => {
                    this.sound = res
                })
            console.log("rendering sound:", this.sound)
        },
        updateDetections(){
            console.log(
                "SoundSingleView.updateDetections",
                this.requesting_user,
                this.id,
            )
            getDetections(this.requesting_user, this.id)
                .then((res, err) => {
                    this.detections = res
                })
            console.log("rendering sound:", this.sound)
        },
        checkCode(){
            
            // get the code
            let queryCode = this.$route.query.code

            // verify that there is a code
            if (!queryCode){
                return false
            }

            // decode the code
            queryCode = codeB64.decode(queryCode)

            // break down the code
            const soundId = queryCode.split(',')[0]
            const dateTime = queryCode.split(',')[1]

            // verify the sound ID
            if (soundId !== this.id) {
                return false
            }
            console.log('soundId okay')
            // verify date
            if (!this.dateWithinRange(dateTime, 3)) {
                return false
            }
            console.log('date okay')
            // if everything is correct, return true
            return true
        },
        dateWithinRange(queryCodeDateTime, rangeInDays) {

            // set both Date() objects
            const currentDate = new Date()
            const queryDate = new Date(queryCodeDateTime)

            // calculate the difference
            const differenceInMilliseconds = Math.abs(queryDate - currentDate)

            // convert difference from milliseconds to days
            const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24)

            // calculate if the difference is within the allowed range
            return differenceInDays <= rangeInDays
        }
    },
    computed: {
        ...mapState(useLogin, ["email", "isAdmin", "tokens"]),
        requesting_user(){
            // If the user is an admin OR they have a special URL,
            // set the user to the email in the query string
            if (this.isAdmin || this.checkCode()) {
                var user = this.$route.query.user
                if (!user) {
                    return this.email
                }
                if (user.length > 5){
                    return user
                }
                return this.email
            }
            else {
                return this.email
            }
        },
        id(){
            return this.$route.params.id
        }
    }
}
</script>

